module.exports = __webpack_public_path__ + "fonts/NotoSans-Black.0725c5a.ttf";